import {Mapper} from '@s-ui/domain'

export class FromUserRawDataToUserEntityMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Function} param.userEntityFactory
   */
  constructor({config, userEntityFactory}) {
    super()

    this._config = config
    this._userEntityFactory = userEntityFactory

    const {PRIVATE_CONTRACT_ID} = this._config.get('dealer')
    this._privateContractId = PRIVATE_CONTRACT_ID
  }

  _getProvince({provinceId}) {
    const provinces = this._config.get('provinces')
    const provinceIdNumber = Number(provinceId)
    const foundProvince = provinces.find(({id, label}) => id === provinceIdNumber)

    return foundProvince?.label
  }

  /**
   * @param {Object} rawData
   * @returns {UserEntity}
   */
  map = rawData => {
    const {
      lastName,
      name = '',
      phone,
      provinceId,
      userId,
      avatarUrl: avatar,
      contractId = String(this._privateContractId),
      zipCode
    } = rawData

    return this._userEntityFactory({
      userId,
      lastName,
      name,
      phone,
      avatar,
      province: this._getProvince({provinceId}),
      contractId,
      zipCode
    })
  }
}
